// Config
export const SET_PAGE_LANGUAGE = 'SET_PAGE_LANGUAGE';

// Header
export const SET_HEADER_ITEM = 'SET_HEADER_ITEM';

// Sidebar
export const SET_IS_CLICKED_MENU_BUTTON = 'SET_IS_CLICKED_MENU_BUTTON';
export const SET_IS_HOVER_MENU = 'SET_IS_HOVER_MENU';
export const SET_SIDEBAR_ITEM = 'SET_SIDEBAR_ITEM';
export const SET_HOTEL_ITEM = 'SET_HOTEL_ITEM';

// Hotel
export const SET_HOTEL_LIST = 'SET_HOTEL_LIST';

// Building List
export const INIT_BUILDING_LIST_STATE = 'INIT_BUILDING_LIST_STATE';
export const SET_BUILDING_LIST = 'SET_BUILDING_LIST';
export const SET_BUILDING_LIST_CURRENT_PAGE_NUMBER = 'SET_BUILDING_LIST_CURRENT_PAGE_NUMBER';
export const SET_BUILDING_PAGINATION_ITEM = 'SET_BUILDING_PAGINATION_ITEM';
export const SET_BUILDING_FILTER_ITEM = 'SET_BUILDING_FILTER_ITEM';

// Floor List
export const INIT_FLOOR_LIST_STATE = 'INIT_FLOOR_LIST_STATE';
export const SET_FLOOR_LIST = 'SET_FLOOR_LIST';
export const SET_FLOOR_LIST_CURRENT_PAGE_NUMBER = 'SET_FLOOR_LIST_CURRENT_PAGE_NUMBER';
export const SET_FLOOR_PAGINATION_ITEM = 'SET_FLOOR_PAGINATION_ITEM';
export const SET_FLOOR_FILTER_ITEM = 'SET_FLOOR_FILTER_ITEM';

// Room List
export const INIT_ROOM_LIST_STATE = 'INIT_ROOM_LIST_STATE';
export const SET_ROOM_LIST = 'SET_ROOM_LIST';
export const SET_ROOM_LIST_CURRENT_PAGE_NUMBER = 'SET_ROOM_LIST_CURRENT_PAGE_NUMBER';
export const SET_ROOM_PAGINATION_ITEM = 'SET_ROOM_PAGINATION_ITEM';
export const SET_ROOM_FILTER_ITEM = 'SET_ROOM_FILTER_ITEM';

// Doorlock List
export const INIT_DOORLOCK_LIST_STATE = 'INIT_DOORLOCK_LIST_STATE';
export const SET_DOORLOCK_LIST = 'SET_DOORLOCK_LIST';
export const SET_DOORLOCK_LIST_CURRENT_PAGE_NUMBER = 'SET_DOORLOCK_LIST_CURRENT_PAGE_NUMBER';
export const SET_DOORLOCK_PAGINATION_ITEM = 'SET_DOORLOCK_PAGINATION_ITEM';
export const SET_DOORLOCK_SORT_ITEM = 'SET_DOORLOCK_SORT_ITEM';
export const SET_DOORLOCK_FILTER_ITEM = 'SET_DOORLOCK_FILTER_ITEM';

// Booking List
export const INIT_BOOKING_LIST_STATE = 'INIT_BOOKING_LIST_STATE';
export const SET_VIEW_TYPE = 'SET_VIEW_TYPE';
export const SET_BOOKING_LIST = 'SET_BOOKING_LIST';
export const SET_BOOKING_LIST_CURRENT_PAGE_NUMBER = 'SET_BOOKING_LIST_CURRENT_PAGE_NUMBER';
export const SET_BOOKING_PAGINATION_ITEM = 'SET_BOOKING_PAGINATION_ITEM';
export const SET_BOOKING_SORT_ITEM = 'SET_BOOKING_SORT_ITEM';
export const SET_BOOKING_FILTER_ITEM = 'SET_BOOKING_FILTER_ITEM';

// Staff List
export const INIT_STAFF_LIST_STATE = 'INIT_STAFF_LIST_STATE';
export const SET_STAFF_LIST = 'SET_STAFF_LIST';
export const SET_STAFF_LIST_CURRENT_PAGE_NUMBER = 'SET_STAFF_LIST_CURRENT_PAGE_NUMBER';
export const SET_STAFF_PAGINATION_ITEM = 'SET_STAFF_PAGINATION_ITEM';
export const SET_STAFF_FILTER_ITEM = 'SET_STAFF_FILTER_ITEM';

// Report List
export const INIT_REPORT_LIST_STATE = 'INIT_REPORT_LIST_STATE';
export const SET_REPORT_LIST = 'SET_REPORT_LIST';
export const SET_REPORT_LIST_CURRENT_PAGE_NUMBER = 'SET_REPORT_LIST_CURRENT_PAGE_NUMBER';
export const SET_REPORT_PAGINATION_ITEM = 'SET_REPORT_PAGINATION_ITEM';
export const SET_REPORT_FILTER_ITEM = 'SET_REPORT_FILTER_ITEM';

// Doorlock TILE List
export const INIT_DOORLOCK_TILE_LIST_STATE = 'INIT_DOORLOCK_TILE_LIST_STATE';
export const SET_DOORLOCK_TILE_LIST = 'SET_DOORLOCK_TILE_LIST';
export const SET_DOORLOCK_TILE_LIST_CURRENT_PAGE_NUMBER = 'SET_DOORLOCK_TILE_LIST_CURRENT_PAGE_NUMBER';
export const SET_DOORLOCK_TILE_PAGINATION_ITEM = 'SET_DOORLOCK_TILE_PAGINATION_ITEM';
export const SET_DOORLOCK_TILE_FILTER_ITEM = 'SET_DOORLOCK_TILE_FILTER_ITEM';